import Checkbox from "@mui/material/Checkbox"
import Tooltip from "@mui/material/Tooltip"
import { useState } from "react"

import { NoWrapTableCell } from "../../../common/components/tables/cells"

export default function SelectMultipleTableCell({
  row,
  rows,
  checkedIDs,
  setCheckedIDS,
  index,
  disabled,
  disabledTooltip,
  CellComponent = NoWrapTableCell,
  cellProps,
}) {
  function handleSelectCandidateCheckboxChanged(e, rowIndex) {
    const affectedCandidate = rows[rowIndex]
    const newCheckedIDs = new Set(checkedIDs)
    if (e.target.checked) {
      newCheckedIDs.add(affectedCandidate.id)
    } else {
      newCheckedIDs.delete(affectedCandidate.id)
    }
    setCheckedIDS(newCheckedIDs)
  }

  return (
    <CellComponent onClick={(e) => e.stopPropagation()} {...cellProps}>
      <Tooltip title={disabled && disabledTooltip ? disabledTooltip : ""}>
        {/* A disabled checkbox fires no events, so the span holds the tooltip. */}
        <span>
          <Checkbox
            size="small"
            color="primary"
            checked={checkedIDs.has(row.id)}
            onChange={(e) => handleSelectCandidateCheckboxChanged(e, index)}
            disabled={disabled}
            inputProps={
              disabled && disabledTooltip
                ? { "aria-label": disabledTooltip }
                : undefined
            }
          />
        </span>
      </Tooltip>
    </CellComponent>
  )
}

export function useSelectMultipleTableCellState() {
  const [checkedIDS, setCheckedIDS] = useState(new Set())
  const checkedIDsArray = checkedIDS.values().toArray()

  function clearSelection() {
    setCheckedIDS(new Set())
  }

  return {
    checkedIDS,
    setCheckedIDS,
    clearSelection,
    checkedIDsArray,
  }
}
